








































import {Component, Vue} from 'vue-property-decorator';
import ChangePasswordDialog from './ChangePasswordDialog.vue';
import {mapActions} from 'vuex';

@Component({
    components: {
        ChangePasswordDialog,
    },
    methods: {
        ...mapActions(['changeLanguage']),
    },
})
export default class UserMenu extends Vue {
    private userMenu: boolean = false;
    public changeLanguage!: Function;

    onChangePassword() {
        (this.$refs.changePasswordDialog as any).open(
            {
                oldPassword: '',
                newPassword: '',
                repeatPassword: '',
            },
            null,
        );
        this.userMenu = false;
    }

    onChangeLanguage(lang: string) {
        if (lang === this.$i18n.locale) return;
        this.userMenu = false;
        this.changeLanguage({i18n: this.$i18n, culture: lang});
    }
}
